class RapiDebugView {
  constructor({ el }) {
    this.elementSelector = document.querySelector(el);
  }

  render(data) {
    if (data && data.rapiDebug && this.elementSelector) {
      this.elementSelector.innerHTML = data.rapiDebug;
    }
  }
}

module.exports = RapiDebugView;
